var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"persons"},[_c('statisticCard',{attrs:{"icon":'mdi-account-supervisor-circle',"color":'blue',"statistic":_vm.statistic,"description":'אברכים קבועים'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }